import { useEffect, useState } from "react";
import { Card, Button, Space, message } from "antd";
// 先注释接口，保留静态页面
// import { getSecuritySetting, saveSecuritySetting } from "../api";

export default function SettingSecurity() {
  // 静态默认值
  const [data, setData] = useState({ 
    allowLogin: true, 
    expireDays: 7 
  });

  // 临时注释接口调用
  useEffect(() => {
    // 对接后端时打开：getSecuritySetting().then(setData);
  }, []);

  const save = (patch) => {
    const merged = { ...data, ...patch };
    // 临时提示，对接后端时替换为接口调用
    // saveSecuritySetting(merged).then(() => {
    //   message.success("已保存");
    //   setData(merged);
    // });
    message.success("保存成功（静态页面，仅做展示）");
    setData(merged);
    console.log("安全设置保存值：", merged);
  };

  return (
    <div>
      <h2>🔒 安全设置</h2>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Card size="small">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>允许用户登录</span>
            <Button
              type={data.allowLogin ? "primary" : "default"}
              onClick={() => save({ allowLogin: !data.allowLogin })}
            >
              {data.allowLogin ? "已开启" : "已关闭"}
            </Button>
          </div>
        </Card>
        <Card size="small">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>登录令牌过期天数</span>
            <Button
              onClick={() =>
                save({ expireDays: data.expireDays === 7 ? 3 : 7 })
              }
            >
              {data.expireDays} 天
            </Button>
          </div>
        </Card>
      </Space>
    </div>
  );
}